import React from 'react';
import { ClippedContent, DateTimeUtils, Icon, Person, Table, } from 'dyl-components';
import { Popup } from 'semantic-ui-react';
import { StringUtils } from 'utils';


export const Row = ({ message }) => {
    return (
        <Table.Row>
            <Table.Cell >
                <div><b>{DateTimeUtils.formatEpoch(message.ts, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(message.ts, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell >
                <div className="MessageHistory__LargeFixedWidth">
                    <ClippedContent>
                        {message?.message}
                    </ClippedContent>
                    <Popup
                        trigger={
                            <Icon
                                link
                                className="fas fa-copy"
                                onClick={StringUtils.copy(message?.message)}
                                color="primary"
                            />
                        }
                        content="Copied!"
                        on="click"
                        closeOnTriggerMouseLeave
                        position="bottom center"
                        inverted
                    />
                </div>
                {message?.link && (
                    <div className="MessageHistory__LargeFixedWidth">
                        <ClippedContent>
                            Link: <a href={message?.link} target="_blank" rel="noreferrer">
                                {message?.link}
                            </a>
                        </ClippedContent>
                    </div>
                )}
            </Table.Cell>
            <Table.Cell >
                {message?.message_type}

            </Table.Cell>
            <Table.Cell >
                {message?.partial_alerts?.permission_type?.join(", ")}

            </Table.Cell>
            <Table.Cell >
                <Person
                    username={
                        message?.created_by?.username
                    }
                    email={message?.created_by?.email}
                    isInactiveUser={!message?.created_by?.active}
                />
            </Table.Cell>
        </Table.Row>
    );
}
